import { VerticalSpacing } from "../../VerticalSpacing";
import { V3TextInput } from "../../TextInput/V3TextInput";
import { V3BodyGrey35 } from "../../ReusableStyledComponents/V3BodyGrey35";
import { AddSourceFormik, getEditOptionsDescriptionText, getInputNamePlaceholder } from "./AddSource.utils";
import { WrapperWithTooltip } from "../../ReusableStyledComponents/WrapperWithTooltip";
import { V3Tooltip } from "../../Tooltip";
import { V3IconHelpCircle } from "../../Icons";
import { V3Button } from "../../Button";
import { V3ButtonColor } from "../../Button/V3Button.types";
import { V3Loader } from "../../Loader";
import { RightAlignPanel } from "../../ReusableStyledComponents/RightAlignPanel";
import { V3CaptionGrey35 } from "../../ReusableStyledComponents/V3CaptionGrey35";
import { FormikProps } from "formik";

interface AddSourceEditOptionsProps {
    formik: FormikProps<AddSourceFormik>;
    loading: boolean;
    onBackHandler: () => void;
}

export const AddSourceEditOptions = ({ formik, loading, onBackHandler }: AddSourceEditOptionsProps) => (
    <form onSubmit={formik.handleSubmit} action=".">
        <VerticalSpacing bottom={24}>
            <VerticalSpacing bottom={24}>
                <V3CaptionGrey35>{getEditOptionsDescriptionText(formik.values.type)}</V3CaptionGrey35>
            </VerticalSpacing>
            <VerticalSpacing bottom={6}>
                <WrapperWithTooltip>
                    <div>
                        <V3BodyGrey35>
                            <strong>Name</strong>
                        </V3BodyGrey35>
                    </div>
                    <div>
                        <V3Tooltip
                            tooltipMaxWidth={220}
                            referenceContent={<V3IconHelpCircle />}
                            tooltipContent={<>This is the name that the source will have in your Authory account.</>}
                        />
                    </div>
                </WrapperWithTooltip>
            </VerticalSpacing>
            <V3TextInput
                name="name"
                placeholder={getInputNamePlaceholder(formik.values.type)}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.name}
                error={formik.errors.hasOwnProperty("name") && formik.touched.hasOwnProperty("name") ? formik.errors.name : undefined}
                disabled={loading}
            />
        </VerticalSpacing>
        <VerticalSpacing bottom={24}>
            <V3CaptionGrey35>Authory will automatically import all your future content from this publication. ✨</V3CaptionGrey35>
        </VerticalSpacing>
        <RightAlignPanel>
            <div>{!loading && <V3Button text="Back" type="button" color={V3ButtonColor.secondary} onClick={onBackHandler} />}</div>
            <div>{loading ? <V3Loader height={42} /> : <V3Button text={"Continue"} onClick={async () => {}} />}</div>
        </RightAlignPanel>
    </form>
);
